import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIsb = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 7,
	viewBox: "0 0 20 7",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M19.9317 0.482073C20.0296 0.308361 20.0026 0.286284 19.9708 0.259433C19.9268 0.225144 19.8876 0.247142 19.7824 0.357288C17.6533 2.68944 15.0055 4.63002 11.9588 4.57867C9.05886 4.53459 7.87693 2.52301 4.97455 1.83294C4.37498 1.69344 3.51605 1.6788 2.92876 1.77665C2.12361 1.91122 0.95386 2.21958 0.156077 2.64787C0.156077 2.64787 -0.0201165 2.74573 0.00190472 2.8118C0.0165908 2.86566 0.0606413 2.86073 0.217256 2.84609C5.04062 2.32973 6.67535 5.2761 9.58751 6.00289C14.078 7.13104 16.8385 4.36088 18.7888 2.00422C19.4569 1.19422 19.7946 0.719508 19.9317 0.482073ZM13.268 0C14.0902 0 14.7535 0.665648 14.7535 1.48786C14.7535 2.30765 14.0902 2.9733 13.268 2.9733C12.4458 2.9733 11.7826 2.30765 11.7826 1.48786C11.7826 0.668075 12.4458 0 13.268 0Z",
		fill: "currentColor"
	})
});
export default SvgIsb;
